module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/1_70bb0aafaa201f00bbe8ec3fff8baca3.png";